import { AxiosCall } from '../axios';

export const changeMyPassword = async (values: {
  new_password: string;
  confirm_password: string;
  old_password: string;
}): Promise<any> => {
  try {
    return await AxiosCall.put('/user/change-password', values);
  } catch (error) {
    if (error && error.response && error.response.data) {
      throw error.response.data;
    } else {
      throw error;
    }
  }
};

export const getAllUsers = async (params: {
  search_text: string;
  fetching_user_type: string;
}): Promise<any> => {
  try {
    let queryParams = '';
    if (params.search_text) {
      queryParams += `search_text=${encodeURIComponent(params.search_text)}`;
    }
    if (params.fetching_user_type) {
      queryParams += queryParams
        ? `&fetching_user_type=${params.fetching_user_type}`
        : `fetching_user_type=${params.fetching_user_type}`;
    }
    return await AxiosCall.get(`/user/all?${queryParams}`);
  } catch (error) {
    if (error && error.response && error.response.data) {
      throw error.response.data;
    } else {
      throw error;
    }
  }
};

export const getAllUsersOfGroup = async (
  groupId: number | string
): Promise<any> => {
  try {
    const requestUrl = `/group/${groupId}/user/all`;
    return await AxiosCall.get(requestUrl);
  } catch (error: any) {
    if (error && error.response && error.response.data) {
      throw error.response.data;
    } else {
      throw error;
    }
  }
};

export const fetchUsersAcrossClinicGroups = async (options?: any): Promise<any> => {
  try {
    let requestUrl = `/admin/system/users/all?limit=${options?.limit || 10
      }&offset=${options?.offset || 0}`;
    if (options?.clinic_group_id) {
      requestUrl += `&clinic_group_id=${options?.clinic_group_id}`
    }
    if (options?.search) {
      requestUrl += `&search_text=${options?.search}`
    }
    return await AxiosCall.get(requestUrl);
  } catch (error: any) {
    if (error && error.response && error.response.data) {
      throw error.response.data;
    } else {
      throw error;
    }
  }
};

export const fetchClinicGroupDetailsOfUser = async (userId: number): Promise<any> => {
  try {
    const requestUrl = `/admin/system/user/${userId}`;
    return await AxiosCall.get(requestUrl);
  } catch (error: any) {
    if (error && error.response && error.response.data) {
      throw error.response.data;
    } else {
      throw error;
    }
  }
};
